import { BIG_ZERO } from 'utils/bigNumber'

export const fetchPublicVaultData = async () => {
  return {
    totalShares: BIG_ZERO.toJSON(),
    pricePerFullShare: BIG_ZERO.toJSON(),
    balanceOf: BIG_ZERO.toJSON(),
    calculateHarvestCakeRewards: BIG_ZERO.toJSON(),
    calculateTotalPendingCakeRewards: BIG_ZERO.toJSON(),
  }
}

export const fetchVaultFees = async () => {
  return {
    performanceFee: 0,
    callFee: 0,
    withdrawFee: 0,
    withdrawFeePeriod: 0,
  }
}

export default fetchPublicVaultData
